var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-share",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-share1",
    serifid: "iconB-share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.842,9.185l5.308,-3.097c-0.098,-0.346 -0.15,-0.711 -0.15,-1.088c0,-2.209 1.791,-4 4,-4c2.209,0 4,1.791 4,4c0,2.209 -1.791,4 -4,4c-1.111,0 -2.117,-0.453 -2.842,-1.185l-5.308,3.097c0.098,0.346 0.15,0.711 0.15,1.088c0,0.377 -0.052,0.741 -0.149,1.087l5.31,3.095c0.725,-0.73 1.729,-1.182 2.839,-1.182c2.209,0 4,1.791 4,4c0,2.209 -1.791,4 -4,4c-2.209,0 -4,-1.791 -4,-4c0,-0.379 0.053,-0.745 0.151,-1.092l-5.309,-3.094c-0.725,0.733 -1.73,1.186 -2.842,1.186c-2.209,0 -4,-1.791 -4,-4c0,-2.209 1.791,-4 4,-4c1.111,0 2.117,0.453 2.842,1.185Zm-1.142,3.87c0.008,-0.017 0.045,-0.081 0.056,-0.096c0.155,-0.285 0.244,-0.612 0.244,-0.959c0,-0.347 -0.089,-0.674 -0.244,-0.959c-0.01,-0.015 -0.02,-0.031 -0.03,-0.047c-0.009,-0.016 -0.018,-0.032 -0.026,-0.049c-0.353,-0.567 -0.982,-0.945 -1.7,-0.945c-1.105,0 -2,0.895 -2,2c0,1.105 0.895,2 2,2c0.718,0 1.347,-0.378 1.7,-0.945Zm8.638,4.833c-0.016,0.035 -0.098,0.176 -0.123,0.208c-0.137,0.272 -0.215,0.579 -0.215,0.904c0,1.105 0.895,2 2,2c1.105,0 2,-0.895 2,-2c0,-1.105 -0.895,-2 -2,-2c-0.693,0 -1.303,0.352 -1.662,0.888Zm-0.094,-11.929c0.01,0.015 0.02,0.031 0.03,0.047c0.009,0.016 0.018,0.032 0.026,0.049c0.353,0.567 0.982,0.945 1.7,0.945c1.105,0 2,-0.895 2,-2c0,-1.105 -0.895,-2 -2,-2c-1.105,0 -2,0.895 -2,2c0,0.347 0.089,0.674 0.244,0.959Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBShare);
export default __webpack_public_path__ + "static/media/iconB-share.24da924654bb8848b87f541ecc8c1fcf.svg";
export { ForwardRef as ReactComponent };